const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

export const compressImageFile = (file: File): Promise<{ name: string; type: string; data: string }> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = () => reject(new Error('Failed to read image'));
    reader.onload = () => {
      const image = new Image();
      image.onerror = () => reject(new Error('Failed to process image'));
      image.onload = () => {
        const scale = Math.min(1, MAX_DIMENSION / Math.max(image.width, image.height));
        const width = Math.round(image.width * scale);
        const height = Math.round(image.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext('2d');
        if (!context) {
          reject(new Error('Could not process image'));
          return;
        }

        context.drawImage(image, 0, 0, width, height);
        const dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
        const base64 = dataUrl.split(',')[1];

        if (!base64) {
          reject(new Error('Could not encode image'));
          return;
        }

        const safeName = file.name.replace(/\.[^.]+$/, '') || 'photo';
        resolve({
          name: `${safeName}.jpg`,
          type: 'image/jpeg',
          data: base64,
        });
      };
      image.src = reader.result as string;
    };

    reader.readAsDataURL(file);
  });
